<template>
  <div>
    <b-row>
      <b-col
          cols="12"
          xl="6"
          md="6"
      >
        <Update />
      </b-col>

      <b-col>
        <MFA />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BCol, BRow } from "bootstrap-vue";

import MFA from "@/pages/auth/profile/mfa.vue";
import Update from "@/pages/auth/profile/update.vue";

export default {
  components: {
    MFA,
    BRow,
    BCol,
    Update,
  },
}
</script>

<style lang="scss">
$neutral : #80A0AF;
$main-color: #011151;

.custom-input {
  position: relative;
  display: block;
  color:  #80A0AF !important;

  .leading{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    padding-left: 12px;
    padding-right: 0.5rem;
    display: flex;
    align-items: center;
  }

  .trailing {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding-right: 12px;
    padding-left: 0.5rem;
    display: flex;
    align-items: center;
  }

  .otp {
    letter-spacing: 2rem;
    font-weight: bold;
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
    padding-left: 3.5rem !important;
  }


  input {
    border: 1px solid $neutral;
    border-radius: 5px;
    width: 100%;
    top: 50%;
    bottom: 50%;
    min-width: 50px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 2.75rem;
    color:  #80A0AF !important;

    &:focus {
      outline: none;
      border: 1px solid $main-color;
    }

    &::placeholder {
      color: $neutral;
      opacity: 0.3;
    }
    &:invalid {
      border-color: red;
    }
    &:required {
      border-color: red;
    }
    &:-ms-input-placeholder {
      color: $neutral;
    }

  }
}

</style>
